import * as u from '@/util/util';
import Vue from 'vue';
import Vuex from 'vuex';
//webSocket
import webSocket from './modules/webSocket';
//打开的标签页
import menuTab from './modules/menuTab';
// 商品
import product from './modules/product';
// 邮件
import mail from './modules/mail';
// 挂载vuex
Vue.use(Vuex);

const store = new Vuex.Store({
  // 全局属性变量
  state: {
    userInfo: u.getSession('userInfo'),
    loading: false,
    tableHeight: 500,
    memberUser: {},
    siteList: [], //站点列表
    setCustomerSiteList: [], //客服系统站点列表
    officialWebsiteSiteList: [], //官网站点列表
    tiesrList: [], //等级列表
    rightList: [], //等级列表
    pointRuleList: [],
    rewardPointsPolicyList: [],
    productTypeList: [],
    siteAndCurrencyList: [],
    triggerTypeList: [],
    templateMappingList: [],
    warrantyApplicationStatusList: [], // 保修申请来源系统列表
    warrantyRejectReasonList: [] // 保修驳回原因列表
  },
  // 全局同步方法, 调用方法,this.$store.commit("xxx")
  mutations: {
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    setLoading(state, data) {
      state.loading = data;
    },
    setSiteList(state, data) {
      state.siteList = data;
    },
    setOfficialWebsiteSiteList(state, data) {
      state.officialWebsiteSiteList = data;
    },
    setCustomerSiteList(state, data) {
      state.setCustomerSiteList = data;
    },
    setTiesrList(state, data) {
      state.tiesrList = data;
    },
    setRightList(state, data) {
      state.rightList = data;
    },
    setPointRuleList(state, data) {
      state.pointRuleList = data;
    },
    setRewardPointsPolicyList(state, data) {
      state.rewardPointsPolicyList = data;
    },
    setProductType(state, data) {
      state.productTypeList = data;
    },
    setSiteAndCurrencyList(state, data) {
      state.siteAndCurrencyList = data;
    },
    setTriggerTypeList(state, data) {
      state.triggerTypeList = data;
    },
    setTemplateMapping(state, data) {
      state.templateMappingList = data;
    },
    setWarrantyApplicationStatus(state, data) {
      state.warrantyApplicationStatusList = data;
    },
    setWarrantyRejectReason(state, data) {
      state.warrantyRejectReasonList = data;
    }
  },
  // 异步方法 调用方法,this.$store.dispatch("xxx")
  actions: {},
  // Vuex属性计算,在视图里面当变量使用
  getters: {},
  // 模块化注册
  modules: {
    webSocket,
    menuTab,
    product,
    mail
  }
});

export default store;
